var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99971 1.92148C9.99971 1.71225 9.83006 1.5426 9.62083 1.5426H8.64648V2.30036H9.62083C9.83015 2.30036 9.99971 2.13071 9.99971 1.92148Z",
    fill: "#8180B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62083 4.62106H8.64648V5.37882H9.62083C9.83006 5.37882 9.99971 5.20917 9.99971 4.99994C9.99971 4.79071 9.83015 4.62106 9.62083 4.62106Z",
    fill: "#8180B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62083 7.69949H8.64648V8.45725H9.62083C9.83006 8.45725 9.99971 8.2876 9.99971 8.07837C9.99971 7.86914 9.83015 7.69949 9.62083 7.69949Z",
    fill: "#8180B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07893 0C7.8697 0 7.70005 0.169649 7.70005 0.37888V1.54267H5.61621V2.30043H7.70005V4.62112H5.61621V5.37888H7.70005V7.69957H5.61621V8.45733H7.70005V9.62112C7.70005 9.83035 7.8697 10 8.07893 10C8.28816 10 8.45781 9.83035 8.45781 9.62112V0.379053C8.45781 0.169738 8.28816 0.000173272 8.07893 0.000173272V0Z",
    fill: "#8180B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99983 0C4.7906 0 4.62095 0.169649 4.62095 0.37888V1.54267H2.53711V2.30043H4.62095V4.62112H2.53711V5.37888H4.62095V7.69957H2.53711V8.45733H4.62095V9.62112C4.62095 9.83035 4.7906 10 4.99983 10C5.20906 10 5.37871 9.83035 5.37871 9.62112V0.379053C5.37871 0.169738 5.20906 0.000173272 4.99983 0.000173272V0Z",
    fill: "#8180B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92155 0C1.71232 0 1.54267 0.169649 1.54267 0.37888V1.54267H0.37888C0.169649 1.54267 0 1.71232 0 1.92155C0 2.13078 0.169649 2.30043 0.37888 2.30043H1.54267V4.62112H0.37888C0.169649 4.62112 0 4.79077 0 5C0 5.20923 0.169649 5.37888 0.37888 5.37888H1.54267V7.69957H0.37888C0.169649 7.69957 0 7.86922 0 8.07845C0 8.28768 0.169649 8.45733 0.37888 8.45733H1.54267V9.62112C1.54267 9.83035 1.71232 10 1.92155 10C2.13078 10 2.30043 9.83035 2.30043 9.62112V0.379053C2.30043 0.169738 2.13078 0.000173272 1.92155 0.000173272V0Z",
    fill: "#8180B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeave);
export default __webpack_public_path__ + "static/media/weave.c1c2372028721b3d6693a0f7b3331791.svg";
export { ForwardRef as ReactComponent };